export const GET_ALL_BOOKING_LIST = "V1_GET_ALL_BOOKING_LIST";
export const LOADING_BOOKING = "V1_LOADING_BOOKING";